import { css } from '@emotion/react';
import { Chart } from '@frontend/charts';
import { DashboardWidget, DashboardWidgetFC } from '@frontend/grid-dashboard';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

/**
 * @dashboard-widget
 *
 * id: unbooked-hours-widget
 * title: Unbooked Hours
 * description: Highlights the number of hours of the day not booked, offering insights into available scheduling opportunities.
 * icon: calendar-small
 */
export const UnbookedHoursWidget: DashboardWidgetFC = () => {
  // SP-TODO: Replace with actual data
  const unbookedHoursPercentage = 88;
  const unbookedHourList: number[] = [90, 75, 82, 56, 88, 75, 115];

  return (
    <DashboardWidget>
      <DashboardWidget.Header />
      <DashboardWidget.Content
        css={[
          contentContainer,
          css`
            .recharts-responsive-container {
              min-height: 0;
            }
          `,
        ]}
      >
        <Text weight='bold' css={{ fontSize: theme.fontSize(24), lineHeight: 1 }}>
          {unbookedHoursPercentage}%
        </Text>
        <Chart.TinyAreaChart data={unbookedHourList} color={theme.colors.success20} />
      </DashboardWidget.Content>
    </DashboardWidget>
  );
};

UnbookedHoursWidget.config = {
  size: 'tiny-slim',
  feature: 'schedule',
};

const contentContainer = css({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
});
